import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HtmlToAdfService {
    private ready: Promise<void> | null = null;
    private mod: any = null;

    private ensureLoaded(): Promise<void> {
        if (!this.ready) {
            this.ready = (async () => {
                const m = await import('./htmltoadf.js');
                if (typeof m.default !== 'function') {
                    throw new Error('htmltoadf.js default export is not callable');
                }
                const resp = await fetch('/assets/js/htmltoadf/htmltoadf_bg.wasm', { cache: 'no-store' });
                await m.default(resp);
                this.mod = m;
            })();
        }
        return this.ready;
    }

    preload(): void {
        void this.ensureLoaded();
    }

    async convert(html: string): Promise<string> {
        await this.ensureLoaded();
        return this.mod.convert(html);
    }
}
